'use client'

import { useContext } from 'react'

import type { ExtendedUser, UserContext as UserContextValue } from '../types'

import { UserContext } from '../contexts/User'

export default function useUser<T extends ExtendedUser>() {
  const userContext = useContext<UserContextValue<T>>(
    UserContext as unknown as React.Context<UserContextValue<T>>,
  )

  return userContext
}
